import produce from "immer";
import { useSelector } from "react-redux";

const useLocalStorage = () => {

  const user = useSelector( state => state.user );

  const userId = user.info?.userId;
  const learnerId = user.info?.learnerId;

  const userData = produce( JSON.parse( localStorage.getItem( 'user.data' ) ) || {}, ( draft ) => {
    if ( ! draft[ userId ] ) {
      draft[ userId ] = {};
    }
    if ( ! draft[ userId ][ learnerId ] ) {
      draft[ userId ][ learnerId ] = {};
    }
  } );

  const setUserData = ( data ) => {
    const mergedUserData = produce( userData, ( draft ) => {
      draft[ userId ][ learnerId ] = {
        ...draft[ userId ][ learnerId ],
        ...data
      };
    } );
    localStorage.setItem( 'user.data', JSON.stringify( mergedUserData ) );
  };

  return {
    userData : userData[ userId ][ learnerId ],
    setUserData
  };

};

export default useLocalStorage;
